"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const MovilesYDispositivosM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== "auto") {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 17.067 13.372" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M0 5.312v6.082c0 1.291.626 1.969 1.817 1.969h2.546c1.191 0 1.817-.687 1.817-1.969V11.3h8.032a2.636 2.636 0 002.169-.91 3.79 3.79 0 00.686-2.424V3.334A3.79 3.79 0 0016.381.91 2.636 2.636 0 0014.212 0H5.469A2.636 2.636 0 003.3.91a3.79 3.79 0 00-.686 2.424v.009h-.8C.626 3.343 0 4.021 0 5.312zm4.355-1.969h-.78v-.009A2.723 2.723 0 014.02 1.6a1.757 1.757 0 011.44-.548h8.74a1.729 1.729 0 011.44.548 2.759 2.759 0 01.446 1.737v4.64a2.723 2.723 0 01-.446 1.737 1.757 1.757 0 01-1.44.548H6.18v-4.95c0-1.272-.651-1.969-1.825-1.969zM.96 11.394V5.312c0-.706.2-.919.849-.919h2.554c.634 0 .849.232.849.919v6.082a1.086 1.086 0 01-.18.724.9.9 0 01-.669.2H1.817a.9.9 0 01-.669-.2 1.07 1.07 0 01-.18-.724z" }),
            react_1.default.createElement("path", { d: "M10.807 17.043h4.26a.51.51 0 00.489-.529.546.546 0 00-.141-.376.464.464 0 00-.347-.153h-4.26a.51.51 0 00-.489.529.546.546 0 00.141.376.464.464 0 00.347.153z", transform: "translate(-2.981 -3.67)" }),
            react_1.default.createElement("path", { d: "M3.435 14.038a.767.767 0 00.171.511.628.628 0 00.471.2.582.582 0 00.471-.2.729.729 0 00.171-.511.646.646 0 10-1.286 0z", transform: "translate(-.992 -3.061)" }))));
};
exports.default = MovilesYDispositivosM;
//# sourceMappingURL=index.js.map